import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useClientCompleteOnboardingMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';

export const useClientCompleteOnboarding = () => {
  const [handle, { loading, error: apolloError }] =
    useClientCompleteOnboardingMutation();

  const error = useError(apolloError);

  return {
    loading,
    error,
    completeOnboarding: useCallback(
      async (id: string) => {
        const res = await handle({ variables: { id } });
        return res.data?.clientCompleteOnboarding;
      },
      [handle]
    ),
  };
};
